<template>
  <div class="panel-item">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>数据展示</div>
    </div>
    <dv-scroll-board :config="config" class="panel-item_datav"/>

    <div v-if="datas.length==0" class="null_box">
      <img class="null_logo" src="../../../../assets/null.png" alt="">
      <div>暂无数据</div>
    </div>

  </div>
</template>

<script>

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    datas: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      config: {
        header: ['分销者名称', '有效付款金额', '有效付款订单', '预估服务费', '有效结算订单', '有效结算金额', '结算服务费',
          '退款率', '产品申样', '添加达人数'],
        data: [],
        headerBGC: '#053355',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        headerHeight: 30,
        hoverPause: true,
        // waitTime: 99999999,
        align: [ 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center'],
        columnWidth: [200,200,200,200,200,200,200,200,200,200,] ,// 这里可以设置一个初始值，后续会根据列数自动调整
        rowNum:10,

      },
      detailVisible: false,
      detail: {},

    }
  },
  mounted() {
  },
  methods: {},
// 修改 watch 中的 datas 处理逻辑
  watch: {
    datas: {
      immediate: true,
      handler(newVal) {
        const newData = newVal.map((item, index) => [
          `<div title="${item.fx_user_name || ''}">${item.fx_user_name || ''}</div>`,
          `<div >${item.sum_pay_amount || ''}</div>`,
          `<div >${item.count_order || ''}</div>`,
          `<div >${item.sum_service_amount || ''}</div>`,
          `<div >${item.settle_count_order || ''}</div>`,
          `<div >${item.settle_sum_pay_amount || ''}</div>`,
          `<div >${item.settle_sum_service_amount || ''}</div>`,
          `<div >${item.refund_rate || ''}</div>`,
          `<div >${item.sample_count || ''}</div>`,
          `<div >${item.add_customers_count || ''}</div>`,

        ])

        this.config = Object.assign({}, this.config, {
          data: newData
        })
      }
    },
  }

}
</script>

<style lang="scss" scoped>

.title_name {
  padding: 30px 0 20px 100px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}


.panel-item {
  width: 100%;
  height: 630px;
  background: url(../../../../assets/_s-image_sector_bg2.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.panel-item_datav {
  padding: 0 30px 30px 30px;
  width: calc(100% - 60px);
  height: calc(100% - 120px);
}

.null_box{
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #3b649c;
  text-align: center;
  font-size: 30px;


  .null_logo{
    width: 300px;
    height: 200px;
  }
}

</style>